import {PlatformKind, DeviceType} from './common'

declare let global: {
  platform: string
}

type UnionKeyToValue<U extends string, V> = {
  [K in U]: V
}

const PlatformKindValues = Object.freeze<UnionKeyToValue<PlatformKind, PlatformKind>>({
  android: 'android',
  ios: 'ios',
  desktop: 'desktop',
})

const deviceOSMap: UnionKeyToValue<PlatformKind, string> = {
  android: 'Android',
  ios: 'iOS',
  desktop: 'Desktop',
}

const deviceTypeMap: UnionKeyToValue<DeviceType, string> = {
  web: 'Web',
  native: 'Native',
}

export const Platform = {
  get deviceType(): DeviceType {
    return Platform.isDesktop ? 'web' : 'native'
  },

  get kind(): PlatformKind {
    return PlatformKindValues.desktop
  },

  get isDesktop() {
    return 'platform' in global && global.platform === PlatformKindValues.desktop
  },

  get isIOS() {
    return Platform.kind === PlatformKindValues.ios
  },

  get isAndroid() {
    return Platform.kind === PlatformKindValues.android
  },

  formatter: {
    get deviceType(): string {
      const result = deviceTypeMap[Platform.deviceType]

      if (!result) {
        throw new Error('Unknown platform')
      }

      return result
    },

    get deviceOs(): string {
      const result = deviceOSMap[Platform.kind]

      if (!result) {
        throw new Error('Unknown platform')
      }

      return result
    },
  },
}
